module.exports = __webpack_public_path__ + "img/bg-smart-home-1.f9794410.jpg";